enum ClassName {
  NO_AUTO_MARGIN = 'AppCustom-noAutopad',
  NO_HEIGHT_MARGIN = 'AppCustom-noHeightMargin',
}

export default ClassName;
